var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('main',{staticClass:"with-tabs",attrs:{"id":"page-main"}},[_c('nav',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'reservation' }}},[_c('i',{staticClass:"icon icon-icon_users"}),_vm._v(" Reservation")])],1)])]),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3b6bf2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/checkin/Index.vue
// module id = 597
// module chunks = 0